module.exports = __webpack_public_path__ + "img/community.31086f13.png";